import styled from "styled-components";

export const ContainerStyledWrapper = styled.div`
  > div:first-child {
    background: ${({ theme }) => theme.colors.primaryLightFill};

    input[type="radio"] {
      width: 0;
    }

    > div:first-child > div:last-child {
      display: flex;
      gap: 24px;
    }
  }
`;

export const StyledForm = styled.form`
  background: ${({ theme }) => theme.colors.primaryLightFill};

  > hr {
    margin-left: 40px;
    margin-right: calc(100% - 749px);
    border-color: ${({ theme }) => theme.colors.primaryRulerTint50};
  }
  > div:last-child {
    width: 100%;
    display: flex;
    justify-content: flex-end;

    > button {
      font-size: 18px;
    }
  }

  > div:first-child {
    padding-bottom: 32px;
  }
`;

export const AccordionContent = styled.div`
  min-width: 850px;
  padding: 50px 40px;
  padding-right: calc(100% - 749px);

  &.button-container {
    padding-top: 32px;

    > button {
      font-weight: 500;
      padding: 24px;
    }
  }
`;
